
import { Prop, Component, Vue } from 'vue-property-decorator'
import { Container } from '@mg/micro/vue2/Container'
import BasicImage from '@mg/web-components/Atoms/Image/BasicImage/index'
import { NuxtError } from '@nuxt/types/app'
import { apolloServiceTranslationQuery } from '~/utils/translationService'

@Component({
  apollo: {
    getTranslations: {
      ...apolloServiceTranslationQuery(['errors']),
    },
  },
  components: { BasicImage, Container },
})
export default class extends Vue {
  @Prop({ type: Object }) error: NuxtError

  mounted() {
    this.$Progress.finish()
  }

  get href() {
    if (typeof window !== 'undefined') {
      return window.location.href
    }
  }

  get errorJson() {
    return window.location.href.includes('0.0.0.0')
      ? JSON.stringify(this.error)
      : ''
  }

  get errorImageUrl() {
    return this.error.statusCode === 404
      ? require('@/assets/image/status-404.png')
      : require('@/assets/image/status-5xx.png')
  }
}
